<template>
  <div class="curriculum" :class="[$config.project, { 'preview-mode': previewMode, 'locked-course': course.status === 'locked' }]">
    <ul class="sections" :class="sectionsLength && !seemore ? 'overlay' : ''">
      <li
        v-for="(section, i) in course.sections"
        :key="i"
        class="section-wrapper"
        :class="{ 'expanded-lessons': expandedLessons.includes(i) }"
      >
        <div class="section" :class="`section-${i}`" @click="toggle(i, $event)">
          <div class="main">
            <Arrow v-if="$config.project === 'site'" class="arrow" />
            <Arrow2 v-else class="arrow2" />
            <div class="section-name-wrap">
              <span class="section-name">{{ `${i + 1}. ${section.name}` }}</span>
              <span v-if="$config.project === 'lms' && !paidAccess && (section.free || course.free)" class="label-sm free-label">Free</span>
            </div>
          </div>
          <div class="info" :class="{ lms: $config.project === 'lms' }">
            <span>{{ section.lessons }} {{ section.lessons > 1 ? 'Lessons' : 'Lesson' }}</span>
            <span class="bullet" />
            <span>{{ section.duration }} Min</span>
          </div>
        </div>
        <div class="lessons">
          <p>{{ section.description }}</p>
          <span
            v-for="(lesson, idx) in section.lectures" :key="`${idx}${lesson.id || lesson.slug}`" class="lesson"
            :class="{ 'text-type-lesson': !lesson.video, 'video-type-lesson': lesson.video }"
            @click="open(lesson)"
          >
            <PlayIcon v-if="lesson.video" />
            <TextIcon v-else />
            <div>
              <span class="lesson-name">{{ lesson.name }}</span>
              <span v-if="$config.project === 'lms' && !paidAccess && (lesson.free || section.free || course.free)" class="label-sm free-label">Free</span>
              <span v-if="$config.project === 'site' && !lesson.video" class="label-sm read-label">Read now</span>
            </div>
            <span class="duration">{{ lesson.duration || 0 }} min</span>
          </span>
        </div>
      </li>
    </ul>
    <div v-if="sectionsLength" class="see-more">
      <a class="link-accent" @click="seeMore($event)">
        <span>See {{ seemore ? 'Less' : 'More' }}</span>
        <ArrowDown />
      </a>
    </div>
  </div>
</template>

<script>
import cookies from 'js-cookie';
import Arrow from '../../assets/svg/icon-arrow-gray.svg?vue-component';
import Arrow2 from '../../assets/svg/icon-arrow-dropdown.svg?vue-component';
import ArrowDown from '../../assets/svg/carret-down.svg?vue-component';
import PlayIcon from '../../assets/svg/courses/icon-lesson-type.svg?vue-component';
import TextIcon from '../../assets/svg/courses/icon-text-lesson-type.svg?vue-component';

export default {
  components: {
    Arrow,
    Arrow2,
    ArrowDown,
    TextIcon,
    PlayIcon,
  },
  props: {
    course: { type: Object, default: () => {}, required: true },
  },
  data() {
    return {
      expandedLessons: [],
      seemore: false,
    };
  },
  computed: {
    paidAccess() {
      return this.course.paidAccess;
    },
    sectionsLength() {
      return this.course.sections.length && this.course.sections.length > 7;
    },
    previewMode() {
      return this.$route.query.preview;
    },
  },
  mounted() {
    setTimeout(() => {
      const lessons = document.querySelector('ul.sections .lessons');
      if (lessons) {
        this.toggle(0, lessons);
      }
    }, 2000);
  },
  methods: {
    open(lesson) {
      if (this.previewMode || this.course.status === 'locked' || (this.$config.project === 'site' && lesson.video)) {
        return false;
      }
      let lecturesSeen = cookies.get('lecturesSeen');
      lecturesSeen = lecturesSeen ? JSON.parse(lecturesSeen) : {};
      if (lecturesSeen[this.course.id]
      && lecturesSeen[this.course.id].length === 2
      && !lecturesSeen[this.course.id].includes(lesson.id) // if the lesson is not in the array
      ) {
        this.$emit('courses-gate');
      } else {
        window.open(`/courses/${this.$route.params.course || this.$route.params.slug}/${lesson.slug}/`, '_blank');
      }
      return true;
    },
    toggle(idx, event) {
      const elem = event && event.target ? event.target.closest('.section').nextElementSibling : event;
      if (this.seemore) this.$el.querySelector('ul.sections').style.height = 'auto';
      const index = this.expandedLessons.indexOf(idx);
      if (index > -1) {
        this.expandedLessons.splice(index, 1);
        elem.style.height = '0px';
      } else {
        this.expandedLessons.push(idx);
        elem.style.height = `${elem.scrollHeight}px`;
      }
    },
    seeMore(event) {
      this.seemore = !this.seemore;
      const elem = event.target.closest('.link-accent').parentElement.previousElementSibling;
      if (this.seemore) {
        elem.style.height = `${elem.scrollHeight}px`;
        setTimeout(() => {
          elem.classList.remove('overlay');
        }, 300);
      } else {
        elem.style.height = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.curriculum {
  .sections {
    padding: 0;
    margin: 0;
    transition: height var(--duration) ease-out;

    &.overlay {
      height: 485px;
      position: relative;
      overflow: hidden;

      &:before {
        content: "";
        position: absolute;
        bottom: 0;
        background:
          linear-gradient(
            0deg,
            var(--main-light) -12.31%,
            rgba(255, 255, 255, 0.94) 30.39%,
            rgba(255, 255, 255, 0) 100%
          );
        width: 100%;
        height: 120px;
        z-index: 1;
      }
    }

    &:not(.overlay) {
      + .see-more {
        padding-top: var(--spacing-32);

        svg {
          transform: rotate(180deg);
        }
      }
    }

    .section-wrapper {
      margin: 0;
      list-style: none;
      border-bottom: 1px solid var(--main-light-shade-3);

      .section {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: var(--spacing-24);
        padding: var(--spacing-20) 0;
        cursor: pointer;

        .main {
          display: flex;
          align-items: center;
          margin-right: auto;
          flex: 0 1 auto;

          .arrow {
            transition: ease all var(--duration);
            transform: rotate(180deg);
            margin-right: var(--spacing-8);
          }

          .arrow2 {
            transition: ease all var(--duration);
            transform: rotate(180deg);
            margin-right: var(--spacing-14);
            flex: 0 0 auto;

            path[fill] {
              fill: var(--main-light-shade-4);
            }
          }

          .section-name-wrap {
            display: flex;
            align-items: center;
          }

          .section-name {
            font-weight: 500;
            text-transform: capitalize;
          }

          .label-sm {
            margin-left: var(--spacing-8);
          }
        }

        .info {
          flex: 1 0 auto;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            color: var(--main-dark-shade-3);

            &.bullet {
              background: var(--main-dark-shade-3);
              height: 4px;
              width: 4px;
              border-radius: 50%;
              margin: 0 var(--spacing-xs);
            }
          }

          &.lms span {
            font-weight: 500;
            font-size: 14px;
          }
        }

        .free-label {
          background: rgba(0, 177, 39, 0.20);
          color: var(--main-green-shade-1);
          font-weight: 600;
        }

        &:hover {
          background: var(--accent-light-1);
        }
      }

      .lessons {
        padding-left: var(--spacing-24);
        transition: height var(--duration) ease-out;
        height: 0;
        overflow: hidden;

        .lesson {
          padding: var(--spacing-6) 0;
          cursor: pointer;
          text-decoration: none;
          display: flex;
          align-items: center;

          svg {
            transform: scale(0.8);
            vertical-align: top;
            flex: 0 0 auto;

            path[fill] {
              fill: var(--main-dark-shade-3);
            }
          }

          > div {
            flex: 1;
            display: flex;
            align-items: center;
          }

          .duration {
            margin-left: auto;
            color: var(--main-dark-light-3);
            font-size: 14px;
            font-weight: 500;
          }

          .lesson-name {
            color: var(--accent-shade-2);
            font-weight: 600;
            margin-left: var(--spacing-12);
            display: flex;
            align-items: center;
          }

          .label-sm {
            margin-left: 8px;
          }

          .free-label {
            background: none;
            color: var(--main-green-shade-1);
            font-weight: 600;
          }

          .read-label {
            color: var(--main-green-shade-1);
            font-weight: 600;
            background: unset;
          }

          &:hover {
            background: var(--accent-light-1);
          }
        }
      }

      &.expanded-lessons {
        padding-bottom: 18.5px;

        .section {
          .main svg.arrow {
            transform: rotate(0deg);
            transition: ease all var(--duration);
          }

          .main svg.arrow2 {
            transition: ease all var(--duration);
            transform: rotate(0deg);
          }
        }
      }
    }
  }

  .see-more {
    text-align: center;

    span {
      color: var(--accent-shade-1);
    }

    svg {
      vertical-align: middle;
      margin-left: var(--spacing-8);
      transition: ease all var(--duration);

      path[fill] {
        fill: var(--accent-shade-1);
      }
    }

    a {
      cursor: pointer;
    }
  }

  &.site {
    .sections .section-wrapper .lessons .lesson.video-type-lesson {
      cursor: default;

      .lesson-name {
        color: var(--main-dark-shade-3);
        font-weight: 500;
      }

      &:hover {
        background: unset;
      }
    }
  }

  &.locked-course,
  &.preview-mode {
    .sections .section-wrapper .lessons .lesson {
      cursor: default;

      .lesson-name {
        color: var(--main-dark-shade-3);
        font-weight: 500;
      }

      &:hover {
        background: unset;
      }
    }
  }

  // &.lms:not(.preview-mode):not(.locked-course) {
  //   .sections .section-wrapper .lessons .lesson .lesson-name {
  //     color: var(--accent-shade-2);
  //     font-weight: 600;
  //   }
  // }

  @include bp($bp-laptop) {
    padding: var(--spacing-48);

    .section-wrapper .lessons {
      .lesson .lesson-name {
        flex: 1;
      }

      p:first-of-type {
        margin-top: 0;
      }
    }
  }

  @include bp($bp-phone) {
    .sections .section-wrapper {
      .lessons {
        .lesson {
          > div {
            display: flex;
            justify-content: space-between;
            width: 100%;

            .lesson-name {
              margin-right: var(--spacing-8);
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
            }
          }
        }
      }

      .section {
        .main {
          width: 100%;

          > div {
            display: flex;
            justify-content: space-between;
            width: 100%;

            .section-name {
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
            }

            .label-sm {
              display: flex;
            }
          }
        }
      }
    }
  }
}

.fa {
  @import '../../assets/sass/fa/components/courses-preview-curriculum.scss';
}
</style>
